import CategoryIcon from '@material-ui/icons/Category';
export const LeeftijdsCategorieIcon = CategoryIcon;

